import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { isPublicPageListed, mergeSiteContent } from "../utils/helpers";

export default function Footer() {
  const [site, setSite] = useState(() => mergeSiteContent());

  useEffect(() => {
    const off = onSnapshot(
      doc(db, "admin", "content"),
      (snap) => setSite(mergeSiteContent(snap.exists() ? snap.data() : {})),
      (err) => console.error("Erreur Firestore Footer:", err)
    );
    return () => off();
  }, []);

  const { texts } = site;
  const showPublicPage = (key) => isPublicPageListed(site, key);
  const currentYear = new Date().getFullYear();
  const footerText = (texts.footerText || `© ${currentYear} Unlimited Session. Tous droits réservés.`)
    .replace(/©\s*\d{4}/, `© ${currentYear}`);

  return (
    <footer className="bg-black text-gray-400 text-sm">
      {/* Haut du footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-20 py-12 grid grid-cols-1 md:grid-cols-4 gap-12">
        {/* Logo */}
        <div className="flex flex-col items-center md:items-start">
          <img src="/logo.png" alt="Unlimited Session Logo" className="h-12 mb-4" />
          <p className="text-xs">
            {footerText}
          </p>
        </div>

        {/* Contenu */}
        <div>
          <h3 className="text-white font-bold mb-4 uppercase text-sm">Contenu</h3>
          <ul className="space-y-2">
            {showPublicPage("videos") && <li><Link to="/videos" className="hover:text-red-500">Vidéos</Link></li>}
            {showPublicPage("studio") && <li><Link to="/studio" className="hover:text-red-500">Studio</Link></li>}
            {showPublicPage("latdior") && <li><Link to="/latdior" className="hover:text-red-500">Latdior</Link></li>}
            {showPublicPage("contact") && <li><Link to="/contact" className="hover:text-red-500">Contact</Link></li>}
          </ul>
        </div>

        {/* Réseaux sociaux */}
        <div>
          <h3 className="text-white font-bold mb-4 uppercase text-sm">Réseaux</h3>
          <ul className="space-y-2">
            {texts.footer_instagram && (
              <li><a href={texts.footer_instagram} target="_blank" rel="noreferrer" className="hover:text-red-500">Instagram</a></li>
            )}
            {texts.footer_twitter && (
              <li><a href={texts.footer_twitter} target="_blank" rel="noreferrer" className="hover:text-red-500">Twitter</a></li>
            )}
            {texts.footer_youtube && (
              <li><a href={texts.footer_youtube} target="_blank" rel="noreferrer" className="hover:text-red-500">YouTube</a></li>
            )}
            {texts.footer_tiktok && (
              <li><a href={texts.footer_tiktok} target="_blank" rel="noreferrer" className="hover:text-red-500">TikTok</a></li>
            )}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="text-white font-bold mb-4 uppercase text-sm">Contact</h3>
          <p className="text-gray-400">
            Des questions ?<br />
            <a href="mailto:unlimitedsession@gmail.com" className="hover:text-red-500">
              unlimitedsession@gmail.com
            </a>
          </p>
        </div>
      </div>

      {/* Bas du footer */}
      {showPublicPage("legal") && (
        <div className="border-t border-gray-800 py-4 text-center text-xs">
          <div className="flex flex-col md:flex-row justify-center gap-4">
            <Link to="/mentions-legales" className="hover:text-red-500">Mentions légales</Link>
            <Link to="/confidentialite" className="hover:text-red-500">Politique de confidentialité</Link>
            <Link to="/cgu" className="hover:text-red-500">Conditions générales</Link>
          </div>
        </div>
      )}
    </footer>
  );
}
